import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

const TriggerGuideHandler = () => {
  const justCompletedPlacementTest = useSelector((state) => state.newOnboarding.placementTest.justCompletedPlacementTest);
  const hasRetrievedCourseDetails = useSelector((state) => state.courses.selectedCourseDetails.hasRetrievedCourseDetails);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (justCompletedPlacementTest && hasRetrievedCourseDetails && location.pathname.includes('/study-area')) {
      // Add query parameter or navigate to trigger UserGuiding
      const currentUrl = new URL(window.location);
      // Use different guide parameter based on device type
      const guideParam = isMobile ? 'mobile-placement-complete' : 'placement-complete';
      currentUrl.searchParams.set('guide', guideParam);
      history.replace(currentUrl.pathname + currentUrl.search);
    }
  }, [justCompletedPlacementTest, hasRetrievedCourseDetails, history, location.pathname]);

  return null; // This component doesn't render anything
};

export default TriggerGuideHandler;
